import React, { useEffect, useState } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Layout from "./components/layout";
import Home from "./routes/home";
import Profile from "./routes/profile";
import Login from "./routes/login";
import CreateAccount from "./routes/create-account";
import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import LoadingScreen from "./components/loading-screen";
import ProtectedRouteUser from "./components/protected-route-user";
import Admin from "./routes/admin";
import ProtectedRouteAdmin from "./components/protected-route-admin";
import AdminLayout from "./components/adminLayout";
import "./static/fonts/font.css";
import Detail from "./routes/detail";
import "react-day-picker/dist/style.css";
import LandingPage from "./routes/landingPage";
import SiteTabPage from "./components/site/main/siteTabComponent";
import Signature from "./routes/signature";
import ContractImage from "./components/home/contractImage";
import DrawingComponent from "./components/detail/drawingComponent";
import DrawPanelComponent from "./components/detail/drawPanelComponent";
import Terms from "./routes/terms";
import Introduction from "./routes/introduction";
import IntroductionImageView from "./components/introduction/IntroductionImageView";
import EnterpriseContractList from "./routes/enterpriseContractList";
import CreateEnterpriseComponent from "./components/enterprise/createEnterpriseComponent";
import AdminAccountComponent from "./components/admin/adminAccountComponent";
import CreateAccountComponent from "./components/admin/createAccountComponent";
import AdminBranchManageComponent from "./components/admin/adminBranchManageComponent";
import EnterpriseContractDetail from "./routes/enterpriseContractDetail";
import ContractViewer from "./routes/contract-viewer";
import MattressPage from "./routes/mattressPage";
import DetailComponent from "./components/detail/detailComponent";
import MattressDetailComponent from "./components/common/ui-components/mattressDetailComponent";
import PlumberPage from "./routes/plumbertPage";
import PlumberDetailComponent from "./components/common/ui-components/plumberDetailComponent";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRouteUser>
        <Layout></Layout>
      </ProtectedRouteUser>
    ),
    children: [
      {
        path: "",
        element: <LandingPage></LandingPage>,
      },
      {
        path: "onsitecontract",
        element: <SiteTabPage></SiteTabPage>,
      },
      {
        path: "contractlist",
        element: <Home></Home>,
      },
      {
        path: "contractlist/detail/:id",
        element: <Detail></Detail>,
        // children: [
        //   {
        //     path: "drawingpanel",
        //     element: <DrawingComponent></DrawingComponent>,
        //   },
        // ],
      },
      {
        path: "mattress",
        element: <MattressPage></MattressPage>,
      },
      {
        path: "mattress/mattressDetail/:id",
        element: <MattressDetailComponent></MattressDetailComponent>,
      },
      {
        path: "plumber",
        element: <PlumberPage></PlumberPage>,
      },
      {
        path: "plumber/plumberDetail/:id",
        element: <PlumberDetailComponent></PlumberDetailComponent>,
      },
      {
        path: "profile",
        element: <Profile></Profile>,
      },
      {
        path: "introduction",
        element: <Introduction></Introduction>,
      },
      {
        path: "introduction-image",
        element: <IntroductionImageView></IntroductionImageView>,
      },
      {
        path: "enterpriseContractList",
        element: <EnterpriseContractList></EnterpriseContractList>,
      },
      {
        path: "enterpriseContractList/detail/:id",
        element: <EnterpriseContractDetail></EnterpriseContractDetail>,
      },
      {
        path: "/createEnterpriseContract",
        element: <CreateEnterpriseComponent></CreateEnterpriseComponent>,
      },
      {
        path: "/createEnterpriseContract/:id",
        element: <CreateEnterpriseComponent></CreateEnterpriseComponent>,
      },
    ],
  },
  {
    path: "/login",
    element: <Login></Login>,
  },

  {
    path: "/introduction-image",
    element: <IntroductionImageView></IntroductionImageView>,
  },
  {
    path: "/contract-viewer/:id",
    element: <ContractViewer></ContractViewer>,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRouteAdmin>
        <AdminLayout></AdminLayout>
      </ProtectedRouteAdmin>
    ),
    children: [
      {
        path: "",
        element: <Admin></Admin>,
      },
      {
        path: "admin-account",
        element: <AdminAccountComponent></AdminAccountComponent>,
      },
      {
        path: "create-account-component",
        element: <CreateAccountComponent></CreateAccountComponent>,
      },

      {
        path: "adminbranch-manage",
        element: <AdminBranchManageComponent></AdminBranchManageComponent>,
      },
    ],
  },
  {
    path: "/signature/:id",
    element: <Signature></Signature>,
  },
  {
    path: "/drawing/:id",
    element: <DrawingComponent></DrawingComponent>,
  },
  {
    path: "/contractImage/:id",
    element: <ContractImage></ContractImage>,
  },
  {
    path: "/terms",
    element: <Terms></Terms>,
  },
]);

const GlobalStyles = createGlobalStyle`
${reset}
* {
  box-sizing: border-box;
  }
body {
  background-color: #fafafa;
  color: black;
  font-family: 'Pretendard';
  &&::placeholder {
    color: #8b8b8b;
    font-weight: 300;
    font-size: 2vw;
    font-family: "Pretendard";
  }
}
`;

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const init = async () => {
    setIsLoading(false);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <GlobalStyles />
      {isLoading ? (
        <LoadingScreen></LoadingScreen>
      ) : (
        <RouterProvider router={router}></RouterProvider>
      )}
    </>
  );
}
export default App;
